import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';

@Component({selector: 'seed-login', templateUrl: './login.component.html', styleUrls: ['./login.component.scss'], providers: [WindowService]})
export class LoginComponent implements OnInit {
    //set page title
    title = 'SIGN IN';

    //define form element
    @ViewChild('username')username : ElementRef;
    @ViewChild('password')password : ElementRef;
    @ViewChild('phone')phone : ElementRef;
    @ViewChild('code')code : ElementRef;

    public lastError : string = null;
    public lastErrorPhone : string = null;

    public sentPhoneValidation : boolean = false;
    windowRef : any;

    constructor(public auth : AuthService, private win : WindowService) {}

    ngOnInit() {
        
    }

    login() {
        this.lastError = null;
        this
            .auth
            .login(this.username.nativeElement.value, this.password.nativeElement.value)
            .catch((error) => {
                this.lastError = error.message;
            });
    }

    loginPhone() {
        this.lastErrorPhone = null;
        let phoneNumber = this.phone.nativeElement.value;
        phoneNumber = phoneNumber.replace(/\D+/g, '');
        if (!phoneNumber.startsWith('+1')) {
            phoneNumber = `+1${phoneNumber}`;
        }
        this
            .auth
            .loginWithPhone(phoneNumber, this.windowRef.recaptchaVerifier)
            .then((confirmation) => {
                this.sentPhoneValidation = true;
                this.windowRef.confirmationResult = confirmation;
            })
        .catch((error) => {
            this.lastErrorPhone = error.message;
        });
    }

    loginVerify() {
        this
            .windowRef
            .confirmationResult
            .confirm(this.code.nativeElement.value)
            .then(this.auth.verify)
            .catch(error => {
                console.log(error);
                this.lastErrorPhone = 'Incorrect verification code entered.'
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.component.ts